import { actionType } from './actions';

const initialState = {
    roles: [],
    fetching: false,
    fetched: false,
    error: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.REQUESTED_ROLE_DATA: {
            return {
                ...state,
                fetching: true,
                fetched: false,
                error: false
            };
        }

        case actionType.REJECTED_ROLE_DATA: {
            return {
                ...state,
                fetching: false,
                fetched: true,
                error: true
            };
        }

        case actionType.FETCH_ROLES: {
            return {
                ...state,
                roles: action.payload,
                fetching: false,
                fetched: true,
                error: false
            };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/services/redux/employee/role/reducers.js